import { ReactNode } from "react"

export interface MenuBoxProps {
    title: string
    subtitle?: string
    icon?: ReactNode
    size: MenuBoxSize
    color: MenuBoxColor
    onClick?: () => void
}

export type MenuBoxSize  = 'sm' | 'md' | 'lg'
export type MenuBoxColor = 'green' | 'yellow' | 'purple'

export const MenuBoxColorMap = new Map<MenuBoxColor, { 
    titleColor: string, 
    borderColor: string, 
    backgroundColor: string, 
    contentColor: string
  }>([
    ['green', { 
      titleColor: '#314d51', 
      borderColor: '#D9E6E8', 
      backgroundColor: '#f0f7f8', 
      contentColor: '#4D797F' 
    }],
    ['yellow', {
      titleColor: '#514b31',
      borderColor: '#E8E4D9',
      backgroundColor: '#f8f6f0',
      contentColor: '#7F764D'
    }],
    ['purple', {
      titleColor: '#453151',
      borderColor: '#E5D9E8',
      backgroundColor: '#f7f0f8',
      contentColor: '#6D4D7F'
    }]
  ])
  
  export const MenuBoxSizeMap = new Map<MenuBoxSize, { 
    size: string,
    titleFontSize: string,
    subtitleFontSize: string
  }>([
    ['sm', { 
      size: '150px',
      titleFontSize: '16px',
      subtitleFontSize: '10px'
    }],
    ['md', {
      size: '250px',
      titleFontSize: '25px',
      subtitleFontSize: '19px'
    }],
    ['lg', {
      size: '350px',
      titleFontSize: '35px',
      subtitleFontSize: '29px'
    }]
  ])
